import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ============================
   FETCH ALL CUSTOMERS
============================ */
export const fetchCustomers = createAsyncThunk(
  "customer/fetchCustomers",
  async ({ page = 1, limit = 10, search = "" }, thunkAPI) => {
    try {
      const res = await api.get(
        `/api/customers?page=${page}&limit=${limit}&search=${search}`
      );
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch customers");
    }
  }
);

/* ============================
   TOGGLE STATUS
============================ */
export const toggleCustomerStatus = createAsyncThunk(
  "customer/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(`/api/customers/${id}/status`);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update status");
    }
  }
);

/* ============================
   SLICE
============================ */
const customerSlice = createSlice({
  name: "customer",
  initialState: {
    customers: [],
    loading: false,
    error: null,
    pagination: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Toggle Status
      .addCase(toggleCustomerStatus.fulfilled, (state, action) => {
        const index = state.customers.findIndex((c) => c._id === action.payload._id);
        if (index !== -1) state.customers[index] = action.payload;
      });
  },
});

export default customerSlice.reducer;